// French for the review queue. The shared review verbs, the refusal reasons in their
// snake_case form, 'Overview', 'Cancel', 'not collected' and the page title live in the common
// catalogue and in registry.fr.ts and are not repeated here.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── the masthead ──
  'what the agents proposed and nobody has held yet':
    'ce que les agents ont proposé et que personne n’a retenu',
  'nothing becomes a fact, a touchpoint or a sent mail without a click here':
    'rien ne devient un fait, un point de contact ou un courriel envoyé sans un clic ici',
  'j/k · a hold · e amend · r refuse · u undo':
    'j/k · a retenir · e amender · r refuser · u annuler',
  'j moves down · k moves up · a holds · e amends · r refuses · u undoes':
    'j descend · k monte · a retient · e amende · r refuse · u annule',
  'Hold all {n}': 'Retenir les {n}',
  'Hold every unheld claim this list matches, across every page; a row the record already answers stays, with the reason on it':
    'Retenir chaque affirmation non retenue que cette liste couvre, sur toutes les pages ; une ligne à laquelle le dossier répond déjà reste, avec la raison inscrite',
  'Holding… {held} of {total}': 'Retenue en cours… {held} sur {total}',
  '{held} held': '{held} retenus',
  '{left} left — the record already answers them; the reason is on each row':
    '{left} laissés – le dossier y répond déjà ; la raison figure sur chaque ligne',
  '{failed} refused the write': '{failed} ont refusé l’écriture',
  '{n} from a source stay for their own Hold all': '{n} venant d’une source restent pour leur propre « Tout retenir »',
  '{n} need a person (drafts, dedupes, rule changes)': '{n} demandent une personne (brouillons, doublons, changements de règle)',
  'Hold all stopped. What was held stays held; nothing else was written.':
    '« Tout retenir » s’est arrêté. Ce qui a été retenu le reste ; rien d’autre n’a été écrit.',
  'Refusal log →': 'Journal des refus →',

  // ── the rail ──
  'Held · 7d': 'Retenus · 7 j',
  'Refused · 7d': 'Refusés · 7 j',
  'Edit distance': 'Distance d’édition',
  'Hot run': 'Exécution à surveiller',
  'Open the desk of the run that filed this': 'Ouvrir le poste de la passe qui a déposé ceci',
  'oldest {date} · from {n} principals': 'le plus ancien {date} · de {n} mandants',
  'the queue is empty': 'la file est vide',
  'the summary has not answered yet': 'le récapitulatif n’a pas encore répondu',
  '{filed} as filed · {amended} amended': '{filed} tels que déposés · {amended} amendés',
  'no refusal in the last seven days': 'aucun refus depuis sept jours',
  'how far your holds moved from the filed text':
    'à quelle distance vos retenues se sont éloignées du texte déposé',
  'nothing has been amended yet, so there is no distance to measure':
    'rien n’a encore été amendé, il n’y a donc aucune distance à mesurer',
  'no run has filed anything yet': 'aucune exécution n’a encore rien déposé',
  '{n}% pushed back': '{n}% renvoyés',
  '{principal} · {filed} filed · {refused} refused': '{principal} · {filed} déposés · {refused} refusés',

  // ── the rail of claims ──
  'The queue': 'La file',
  'Untreated': 'Non traités',
  'Treated': 'Traités',
  '{n} of {total}': '{n} sur {total}',
  'clean': 'net',
  'collides': 'collision',
  'no evidence': 'aucune preuve',
  'not on record': 'pas au dossier',
  'Nothing is waiting for you': 'Rien ne vous attend',
  'Nothing has been treated yet': 'Rien n’a encore été traité',
  'A row appears here when an agent, a monitor or the seed importer files a proposal. Nothing writes to the record without passing through this queue.':
    'Une ligne apparaît ici dès qu’un agent, un moniteur ou l’import initial dépose une proposition. Rien ne s’écrit au dossier sans passer par cette file.',
  'The filter on this list excludes every claim. There are claims — just not these.':
    'Le filtre de cette liste exclut toutes les affirmations. Il y en a — mais pas celles-ci.',
  'The queue could not be read': 'La file n’a pas pu être lue',
  'This claim could not be read': 'Cette affirmation n’a pas pu être lue',
  'Choose a claim on the left.': 'Choisissez une affirmation à gauche.',

  // ── the kinds ──
  'fact': 'fait',
  'affiliation': 'affiliation',
  'touchpoint': 'point de contact',
  'commitment': 'engagement',
  'persona': 'persona',
  'draft mail': 'courriel en projet',
  'candidate person': 'personne candidate',
  'signal action': 'action sur signal',
  'rule change': 'changement de règle',
  'update': 'mise à jour',
  'new': 'nouveau',
  'current role': 'rôle actuel',
  'past role': 'rôle passé',
  'mail in': 'courriel entrant',
  'mail out': 'courriel sortant',
  'meeting': 'rencontre',
  'call': 'appel',
  'note': 'note',
  'post': 'publication',
  'signal': 'signal',
  'no descriptor was filed': 'aucune description n’a été déposée',

  // ── the stand ──
  'filed by': 'déposé par',
  'on': 'le',
  'collides with a held value': 'entre en collision avec une valeur retenue',
  'not checked against the record': 'non vérifié contre le dossier',
  'What would enter the record': 'Ce qui entrerait au dossier',
  'a new row': 'une nouvelle ligne',
  // ── round 6: the chained hold ──
  'Holds also': 'Retient aussi',
  'pending': 'en attente',
  '{n} proposal waits on this': '{n} proposition attend celle-ci',
  '{n} proposals wait on this': '{n} propositions attendent celle-ci',
  'Also held first: {list}.': 'Retenu d’abord : {list}.',
  'also held': 'retenu aussi',
  '(the undo does not walk it back)': '(l’annulation ne le reprend pas)',
  'The filing carries no readable field.': 'Le dépôt ne porte aucun champ lisible.',
  'What you hold is what is written; the filed text stays beside it in the ledger.':
    'Ce que vous retenez est ce qui s’écrit ; le texte déposé reste à côté dans le journal.',
  'filed {date}': 'déposé le {date}',
  'would mint': 'frapperait',

  'Validation': 'Validation',
  'PASS': 'OK',
  'WARN': 'ATTENTION',
  'The filing carries {n} piece of evidence.': 'Le dépôt porte {n} preuve.',
  'The filing carries {n} pieces of evidence.': 'Le dépôt porte {n} preuves.',
  'Nothing was cited. This claim is asserted, not evidenced.':
    'Rien n’a été cité. Cette affirmation est avancée, non prouvée.',
  'Every citation names its source or quotes it verbatim.':
    'Chaque citation nomme sa source ou la cite mot pour mot.',
  'The evidence names no source and quotes nothing.': 'La preuve ne nomme aucune source et ne cite rien.',
  'The filing carries every field the write needs.':
    'Le dépôt porte tous les champs dont l’écriture a besoin.',
  'The filing is missing {fields}. Holding it would be refused.':
    'Il manque {fields} au dépôt. Le retenir serait refusé.',
  'A {kind} write is registered; holding this performs it.':
    'Une écriture de type {kind} est enregistrée ; la retenue l’exécute.',
  'Nothing can hold a {kind} proposal yet. Nothing would be written.':
    'Aucune proposition de type {kind} ne peut encore être retenue. Rien ne serait écrit.',
  'The record already holds {n} row this would land beside.':
    'Le dossier tient déjà {n} ligne à côté de laquelle celle-ci se poserait.',
  'The record already holds {n} rows this would land beside.':
    'Le dossier tient déjà {n} lignes à côté desquelles celle-ci se poserait.',
  'Nothing on the record answers to this yet.': 'Rien au dossier n’y répond encore.',
  'The collision check did not run. This claim has NOT been checked against the record.':
    'La vérification des collisions n’a pas tourné. Cette affirmation n’a PAS été confrontée au dossier.',

  'What the record already says': 'Ce que le dossier dit déjà',
  'not checked': 'non vérifié',
  '{n} collision': '{n} collision',
  '{n} collisions': '{n} collisions',
  'Holding this supersedes it; the old value stays in the history.':
    'La retenue la remplace ; l’ancienne valeur reste dans l’historique.',

  'Evidence': 'Preuves',
  '{n} span': '{n} passage',
  '{n} spans': '{n} passages',
  'no source named': 'aucune source nommée',
  'The citation carries a source but no quoted span.':
    'La citation porte une source mais aucun passage cité.',
  'url': 'URL',
  'snapshot': 'capture',
  'interaction': 'point de contact',
  'document': 'document',
  'manual': 'manuel',

  'Why it was proposed': 'Pourquoi cela a été proposé',
  'The filing carries no rationale. What stands behind it is the evidence above and nothing else.':
    'Le dépôt n’avance aucune justification. Derrière lui il y a la preuve ci-dessus et rien d’autre.',

  'Holding this writes': 'Retenir écrit',
  '{ref} {key} · one fact revision with its evidence link · one supersession. Nothing else moves.':
    '{ref} {key} · une révision de fait avec son lien de preuve · un remplacement. Rien d’autre ne bouge.',
  '{ref} {key} · one fact with its evidence link. Nothing else moves.':
    '{ref} {key} · un fait avec son lien de preuve. Rien d’autre ne bouge.',
  'the proposed affiliation at {org} flips from proposed to held. Nothing else moves.':
    'l’affiliation proposée chez {org} passe de proposée à retenue. Rien d’autre ne bouge.',
  'one interaction {ref} with its participants. Nothing else moves.':
    'un point de contact {ref} avec ses participants. Rien d’autre ne bouge.',
  'one open commitment {ref}, owed by {owner}. Nothing else moves.':
    'un engagement ouvert {ref}, dû par {owner}. Rien d’autre ne bouge.',
  'one person {ref} with status held. Nothing else moves.':
    'une personne {ref} au statut retenu. Rien d’autre ne bouge.',
  'one person {ref} with status held, and one held affiliation. Nothing else moves.':
    'une personne {ref} au statut retenu et une affiliation retenue. Rien d’autre ne bouge.',
  'one organisation {ref}. Nothing else moves.': 'une organisation {ref}. Rien d’autre ne bouge.',
  'one outbox row, status approved, addressed to {to}. It is not sent — sending is a separate click.':
    'une ligne de courrier sortant, statut approuvé, adressée à {to}. Elle n’est pas envoyée — l’envoi est un clic séparé.',
  'the signal is stamped dispositioned, and one chained draft proposal is filed for the operator to hold separately. Nothing is sent.':
    'le signal est marqué comme disposé, et une proposition de brouillon enchaînée est déposée, que la personne opératrice retient séparément. Rien n’est envoyé.',
  'one open commitment {ref}, owed by us, and the signal is stamped dispositioned. Nothing else moves.':
    'un engagement ouvert {ref}, dû par nous, et le signal est marqué comme disposé. Rien d’autre ne bouge.',
  'one open commitment, owed by us, and the signal is stamped dispositioned. Nothing else moves.':
    'un engagement ouvert, dû par nous, et le signal est marqué comme disposé. Rien d’autre ne bouge.',
  'one held personas row with {n} trait(s); any previous held version for this subject is superseded. Nothing else moves.':
    'une ligne personas retenue avec {n} trait(s) ; toute version retenue précédente pour ce sujet est remplacée. Rien d’autre ne bouge.',
  'one skill-body file written beside the repo (not into it) and one settings_history row for {target}. Nothing else moves.':
    'un fichier de corps de compétence écrit à côté du dépôt (pas dedans) et une ligne settings_history pour {target}. Rien d’autre ne bouge.',
  'one app_settings row for scoring.rules and one settings_history row; a rescore is queued. Nothing else moves.':
    'une ligne app_settings pour scoring.rules et une ligne settings_history ; une réévaluation est mise en file. Rien d’autre ne bouge.',
  'nothing — no applier is registered for {kind}, so the hold would be refused.':
    'rien — aucune écriture n’est enregistrée pour {kind}, la retenue serait refusée.',

  // ── the foot ──
  'Hold it': 'Retenir',
  'Hold both': 'Retenir les deux',
  'Hold all': 'Tout retenir',
  'Amend, then hold': 'Amender, puis retenir',
  'Hold the amended text': 'Retenir le texte amendé',
  'Refuse because': 'Refuser parce que',
  'a note for the run (optional)': 'une note pour l’exécution (facultatif)',
  'wrong evidence': 'preuve erronée',
  'not relevant': 'non pertinent',
  'out of scope': 'hors périmètre',
  'Delete…': 'Supprimer…',
  'Remove the filing from the queue. Only an unheld or refused one may go.':
    'Retirer le dépôt de la file. Seul un dépôt non retenu ou refusé peut partir.',
  'Delete this filing?': 'Supprimer ce dépôt ?',
  'Delete it': 'Supprimer',
  'The proposal leaves the queue for good, with its payload and its evidence. The audit log keeps what it said. Nothing in the record changes.':
    'La proposition quitte la file pour de bon, avec sa charge et ses preuves. Le journal d’audit garde ce qu’elle disait. Rien ne change au dossier.',
  '{i} of {n}': '{i} sur {n}',

  // ── the session ledger ──
  'This session': 'Cette session',
  'what you disposed of since this server started · an undo reaches no further':
    'ce que vous avez tranché depuis le démarrage de ce serveur · une annulation ne va pas plus loin',
  'undone': 'annulé',

  // ── toasts ──
  'Held. {ref} wrote {applied}.': 'Retenu. {ref} a écrit {applied}.',
  'Amended and held. {ref} wrote {applied}.': 'Amendé et retenu. {ref} a écrit {applied}.',
  'no ref': 'aucune référence',
  'Refused: {reason}. {ref} wrote nothing.': 'Refusé : {reason}. {ref} n’a rien écrit.',
  '{ref} is unheld again.': '{ref} n’est de nouveau pas retenu.',
  '{ref} is gone from the queue.': '{ref} a quitté la file.',
  'The hold failed. Nothing was written.': 'La retenue a échoué. Rien n’a été écrit.',
  'The refusal failed.': 'Le refus a échoué.',
  'The undo was refused.': 'L’annulation a été refusée.',
  'The deletion failed.': 'La suppression a échoué.',

  // ── round 3: a run's raster cells as one group ──
  'Profile': 'Profil',
  '{n} cell': '{n} cellule',
  '{n} cells': '{n} cellules',
  'Hold all cells': 'Retenir toutes les cellules',
  'Hold every non-colliding cell of this run in one transaction; a cell whose current value differs stays for a per-cell decision': 'Retenir en une transaction chaque cellule de ce passage qui n’entre pas en collision ; une cellule dont la valeur actuelle diffère reste pour une décision cellule par cellule',
  '{held} cells held · {collided} left for a per-cell decision': '{held} cellules retenues · {collided} laissées pour une décision cellule par cellule',
  'The group hold failed. Nothing was written.': 'La prise groupée a échoué. Rien n’a été écrit.',

  // ── round 6: les propositions d'une source comme un seul groupe (BUILD-BRIEF-R6 §5.2) ──
  'source': 'source',
  'Hold every non-colliding proposal of this source in one transaction; a colliding row stays for its own click':
    'Retenir en une transaction chaque proposition de cette source qui n’entre pas en collision ; une ligne en collision reste pour son propre clic',

  // ── round 4: le dédoublonnage des organisations (le chercheur propose, l’opérateur décide) ──
  'dedupe': 'doublon',
  'merge': 'fusionner',
  'relate': 'rattacher',
  'not a duplicate': 'pas un doublon',
  'the names are near-identical': 'les noms sont presque identiques',
  'they share a domain': 'elles partagent un domaine',
  'they carry the same UID': 'elles portent le même IDE',
  'the same people are affiliated to both': 'les mêmes personnes sont rattachées aux deux',
  'one name is already an alias of the other': 'un nom est déjà un alias de l’autre',
  'only punctuation and case differ': 'seules la ponctuation et la casse diffèrent',
  'two rows, side by side': 'deux lignes côte à côte',
  'survivor': 'ligne conservée',
  'parent': 'société mère',
  'child': 'filiale',
  'domains': 'domaines',
  'UID': 'IDE',
  'canton': 'canton',
  'open deals': 'affaires ouvertes',
  'facts': 'faits',
  'created': 'créé',
  'and {n} more': 'et {n} de plus',
  'score': 'score',
  'operator': 'opérateur',
  'agent': 'agent',
  'import': 'import',
  'The filing does not name a pair.': 'Le dépôt ne nomme aucune paire.',
  'The pair could not be read. Neither row is shown, so nothing here should be held.':
    'La paire n’a pas pu être lue. Aucune des deux lignes n’est montrée : rien ne devrait être retenu ici.',
  '{n} reason': '{n} raison',
  '{n} reasons': '{n} raisons',
  'The finder paired them without saying why. A score is not a reason.':
    'Le chercheur les a appariées sans dire pourquoi. Un score n’est pas une raison.',
  '{n} affiliation': '{n} affiliation',
  '{n} affiliations': '{n} affiliations',
  '{n} interaction': '{n} échange',
  '{n} interactions': '{n} échanges',
  '{n} commitment': '{n} engagement',
  '{n} commitments': '{n} engagements',
  '{n} deal': '{n} affaire',
  '{n} deals': '{n} affaires',
  '{n} fact': '{n} fait',
  '{n} facts': '{n} faits',
  'interactions not collected': 'échanges non relevés',
  'commitments not collected': 'engagements non relevés',
  'everything that points at it': 'tout ce qui pointe vers elle',
  'Holding this archives {b} into {a}: {moves} move; {bname} becomes an alias of {aname}. This cannot be undone from here; the archived row keeps merged_into.':
    'Retenir ceci archive {b} dans {a} : {moves} changent de main ; {bname} devient un alias de {aname}. Cela ne peut pas être défait d’ici ; la ligne archivée conserve merged_into.',
  'Holding this sets {b}’s parent to {a}.': 'Retenir ceci fixe la société mère de {b} à {a}.',
  'Holding this records that the two are not the same and hides the pair from future runs.':
    'Retenir ceci consigne que les deux ne sont pas la même et masque la paire lors des prochains passages.',
  'nothing — the filing does not name a pair, so the hold would be refused.':
    'rien — le dépôt ne nomme aucune paire, la retenue serait refusée.',
  'cannot be undone here': 'ne peut être défait d’ici',
  'the archived organisation keeps merged_into': 'l’organisation archivée conserve merged_into',
  'affiliations not collected': 'affiliations non relevées',
  'deals not collected': 'affaires non relevées',
  'facts not collected': 'faits non relevés',

  // ── round 3b : le genre « domain » ──
  'domain': 'domaine',
  'found by {source}': 'trouvé par {source}',
  'harvest': 'récolte',
  'directory': 'annuaire',
  // ── round 5 : le genre « link » ──
  'link': 'lien',

  'Holding this sets the website and fetches the logo: {host} is appended to {org}’s domains, and the logo pass runs for it. Nothing else moves.':
'Retenir inscrit le site et récupère le logo : {host} est ajouté aux domaines de {org}, et la passe de logo s’exécute pour elle. Rien d’autre ne bouge.',

  // ── round 5 : le panneau « link » (§6.4/§6.6) ──
  '(regime)': '(régime)',
  'of participants': 'des participants',
  'of revenue': 'des produits',
  'estimated': 'estimé',
  'read': 'lecture',
  'declared': 'déclaré',
  'not_found': 'non trouvé',
  'the quote does not name the counterpart — check the resolution':
    'la citation ne nomme pas la contrepartie — vérifier la résolution',
  'the quote does not name the subject — check the resolution':
    'la citation ne nomme pas l’organisation — vérifier la résolution',
  'with the {n} other lines of this distribution: {sum} %':
    'avec les {n} autres lignes de cette répartition : {sum} %',
  'One link on {ref} {name}: {counterpart} · {role} · {quantity} ({year}). Nothing else moves.':
    'Un lien sur {ref} {name} : {counterpart} · {role} · {quantity} ({year}). Rien d’autre ne bouge.',
  'One link on {ref} {name}: {counterpart} · {role} · {quantity} ({year}), and the {cyear} row ({clabel}) is superseded, undoable. Nothing else moves.':
    'Un lien sur {ref} {name} : {counterpart} · {role} · {quantity} ({year}), et la ligne {cyear} ({clabel}) est remplacée, réversible. Rien d’autre ne bouge.',
  'One link on {ref} {name}: {counterpart} · {role}. Nothing else moves.':
    'Un lien sur {ref} {name} : {counterpart} · {role}. Rien d’autre ne bouge.',

  // ── round 7 §6.3 : une cellule de personne dans le pupitre ──
  // Le nom de la cellule et le mot de son genre viennent de person-raster.v1.ts (personLabelFor,
  // personKindLabel) et ne figurent PAS ici — une deuxième orthographe serait une deuxième vérité.
  'cell': 'cellule',
  'always your click': 'toujours votre clic',
  'A birth year or decade, and any value a broker asserted, is never held on arrival: this one waits for a person, whatever the standing instruction says.':
    'Une année ou une décennie de naissance, et toute valeur affirmée par un courtier, ne sont jamais retenues à l’arrivée : celle-ci attend une personne, quoi que dise l’instruction permanente.',
  'Hold the {n} left anyway': 'Retenir quand même les {n} restants',
  'Hold the rows the rule guards too. Each one is written through the same applier and its objection is noted on the row.': 'Retenir aussi les lignes que la règle protège. Chacune est écrite par le même applier, et son objection est inscrite sur la ligne.',
  'Hold the {n} the rule left?': 'Retenir les {n} laissés par la règle ?',
  'Hold them all': 'Tout retenir',
  'Each of these was left because the record already answers it. Holding them writes every one through the same applier, and the objection it overruled is written on the row.': 'Chacune de ces lignes est restée parce que le dossier y répond déjà. Les retenir écrit chacune par le même applier, et l’objection passée outre est inscrite sur la ligne.',
  '{n} of them over the rule’s objection, noted on each row': 'dont {n} malgré l’objection de la règle, inscrite sur chaque ligne',
  'Nothing could be held automatically — every one of the {left} is guarded':
    'Rien n’a pu être retenu automatiquement — les {left} sont tous protégés',
  '{n} not reached — press Hold all again':
    '{n} non atteints — appuyez à nouveau sur « Tout retenir »',
  'Why the queue did not move':
    'Pourquoi la file n’a pas bougé',
  'Every one of these was left on purpose. They are not errors, and none of them is waiting on the machine — each needs a decision only you can make.':
    'Chacun d’eux a été laissé volontairement. Ce ne sont pas des erreurs, et aucun n’attend la machine — chacun demande une décision que vous seul pouvez prendre.',
  'One of these is the expensive one: a person whose name is already on the record becomes a SECOND row for the same human. A merge now exists (scripts/person-merge-dry-run.ts) and joins two rows onto one survivor, so it is no longer irreversible — but it is a script a person runs and reads, not a click here. Everything else supersedes, chains or can be archived. Narrow the Kind filter first if you want to hold the rest without the people.':
    'L’une d’elles est la coûteuse : une personne dont le nom figure déjà au dossier devient une SECONDE ligne pour le même être humain. Une fusion existe désormais (scripts/person-merge-dry-run.ts) et réunit deux lignes sur un survivant : ce n’est donc plus irréversible — mais c’est un script qu’une personne lance et lit, pas un clic ici. Tout le reste se supplante, s’enchaîne ou peut être archivé. Restreignez d’abord le filtre Type si vous voulez retenir le reste sans les personnes.',
  'Auto-accept…':
    'Acceptation automatique…',
  'Choose which kinds of judgement the rule may stop asking about. A waived class is held automatically, on this backlog and on everything that arrives after.':
    'Choisissez quels types de jugement la règle peut cesser de poser. Une classe levée est retenue automatiquement — pour cet arriéré et pour tout ce qui arrive ensuite.',
  'What may be held without asking you?':
    'Que peut-on retenir sans vous demander ?',
  'Asking the rule about every unheld row…':
    'La règle est interrogée sur chaque ligne en attente…',
  '{unheld} unheld · {holdable} would be held by a plain Hold all today. Each switch below turns off ONE kind of judgement, for this backlog and for everything that arrives after it.':
    '{unheld} en attente · {holdable} seraient retenus aujourd’hui par un simple « Tout retenir ». Chaque interrupteur ci-dessous désactive UN type de jugement, pour cet arriéré et pour tout ce qui arrive ensuite.',
  'held without asking':
    'retenu sans demander',
  'needs you':
    'vous demande',
  'Two guards have no switch and never will: birth data filed into a cell that is not the birth cell, and a filing naming no cell, subject or counterpart. Holding either writes something no reader of that cell expects.':
    'Deux garde-fous n’ont pas d’interrupteur et n’en auront jamais : une donnée de naissance déposée dans une cellule qui n’est pas la cellule de naissance, et un dépôt ne nommant ni cellule, ni sujet, ni contrepartie. Retenir l’un ou l’autre écrit quelque chose qu’aucun lecteur de cette cellule n’attend.',
  'rows are guarded that way now.':
    'lignes sont protégées ainsi actuellement.',
  'The guards could not be counted.':
    'Les garde-fous n’ont pas pu être comptés.',
  'The waiver was not saved.':
    'La levée n’a pas été enregistrée.',
  '{n} guard(s) waived. New arrivals in those classes are held without asking.':
    '{n} garde-fou(s) levé(s). Les nouveaux arrivages de ces classes sont retenus sans demander.',
  'Every guard is back on. Nothing is held without a person.':
    'Tous les garde-fous sont réactivés. Rien n’est retenu sans une personne.',
  'Waiting on an organisation still in Review':
    'En attente d’une organisation encore en revue',
  'Surfe said it':
    'Surfe l’a affirmé',
  'A birth or age cell':
    'Une cellule de naissance ou d’âge',
  'An estimate over a value already held':
    'Une estimation par-dessus une valeur déjà retenue',
  'A name already on the record':
    'Un nom déjà présent au dossier',
  'A value you typed yourself':
    'Une valeur que vous avez saisie vous-même',
  'The organisation is held first, in the same click. Nothing is lost — this is only an ordering.':
    'L’organisation est retenue d’abord, dans le même clic. Rien n’est perdu — ce n’est qu’un ordre.',
  'Surfe’s answer is written as a fact without a person reading it first. It is still marked as Surfe’s and still cites the snapshot.':
    'La réponse de Surfe est écrite comme un fait sans qu’une personne l’ait lue d’abord. Elle reste marquée comme venant de Surfe et cite toujours l’instantané.',
  'Age and birth data go onto the record without a person deciding. You asked for this guard yourself on 07.09.2026; the LPD information duty still applies.':
    'L’âge et les données de naissance entrent au dossier sans qu’une personne décide. Vous avez demandé ce garde-fou vous-même le 07.09.2026 ; le devoir d’information LPD s’applique toujours.',
  'An ESTIMATE supersedes a value already on the record. The old value stays in the history, marked superseded.':
    'Une ESTIMATION supplante une valeur déjà au dossier. L’ancienne valeur demeure dans l’historique, marquée supplantée.',
  'A SECOND row is created for a person or organisation whose name is already there. The merge script joins them afterwards; nothing joins them by itself.':
    'Une SECONDE ligne est créée pour une personne ou une organisation dont le nom figure déjà. Le script de fusion les réunit ensuite ; rien ne les réunit tout seul.',
  'A machine reading supersedes a value YOU TYPED. This is the only one that overwrites your own words.':
    'Une lecture machine supplante une valeur QUE VOUS AVEZ SAISIE. C’est la seule qui écrase vos propres mots.',
}, 'ReviewPage');
